<template>
  <a href="javascript:void(0)" @click="onClick">
    <slot name="name" />
  </a>
  <DefDarkenBackground v-if="isOpen" @close="close" />
  <DefSlideRight>
    <SovaClub v-if="isOpen" class="sova-club-wrapper" :result="club?.data" @close="close" />
  </DefSlideRight>
</template>

<script setup>
import { defineProps, computed, ref, onMounted } from 'vue';
import DefDarkenBackground from '@components/Def/DefDarkenBackground/DefDarkenBackground.vue';
import DefSlideRight from '@components/Def/DefAnimations/DefSlideRight.vue';
import SovaClub from '@components/SovaClub/SovaClub.vue';
import { useStore } from '@store';

const { params } = defineProps(['params']);
const isOpen = ref(false);
const {
  state: { club },
  commit,
  getters,
} = useStore();
const close = () => {
  const item = itemByPageUrl?.value;
  if (item?.id) {
    window.sessionStorage.setItem(`isSovaClubModal${item.id}WasShown`, true);
  }
  if (club?.data?.complete) {
    isOpen.value = false;
    window.location.reload();
  } else {
    isOpen.value = false;
  }
};
const itemByPageUrl = computed(() => getters['club/getItemByPageUrl']);
const itemByClick = computed(() => getters['club/getItemByClick']);

const onClick = () => {
  isOpen.value = true;
  commit('club/setAutoOpen', false);
};

const openModal = () => {
  try {
    const item = itemByPageUrl?.value;
    if (item?.id) {
      const isClubModalWasShown = window.sessionStorage.getItem(
        `isSovaClubModal${item.id}WasShown`
      );
      if (!isClubModalWasShown) {
        setTimeout(() => {
          isOpen.value = true;
          commit('club/setAutoOpen', true);
        }, item.timeout * 1000);
      }
    }
  } catch (err) {
    console.error(err);
  }
};
onMounted(() => {
  openModal();
});
</script>

<script>
export default {
  name: 'SovaClubWrapper',
};
</script>

<style lang="scss" scoped>
.sova-club-wrapper {
  position: fixed;
  z-index: 1001;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  width: 100%;
  @include point-md {
    width: 640px;
  }
  @include point-lg {
    width: 840px;
  }
}
</style>
